import React, { Component } from 'react';
import { Link } from 'react-router-dom';
import {
  Button,
  Card,
  CardHeader,
  ListGroup,
  ListGroupItem } from 'reactstrap';

class ListText extends Component {
  render() {
    return (
      <div>
        <Card className="text-left dark-shadow mb-3 animated fadeInUp delay-200ms">
          <CardHeader>What number should we text?</CardHeader>
          <ListGroup>
            <ListGroupItem tag={Link} to={{pathname: 'code', state: { prevPath: this.props.location.pathname, number: '1293' }}} className="d-flex">
              <div>
                <h3 className="text-primary" style={{ marginBottom: '4px' }}>(***) ***-1293</h3>
              </div>
              <Button color="primary" className="btn-icon ml-auto" tag="div"><img src="/icons/arrow-right.svg" alt="Select" /></Button>
            </ListGroupItem>
            <ListGroupItem tag={Link} to={{pathname: 'code', state: { prevPath: this.props.location.pathname, number: '4473' }}} className="d-flex">
              <div>
                <h3 className="text-primary" style={{ marginBottom: '4px' }}>(***) ***-4473</h3>
              </div>
              <Button color="primary" className="btn-icon ml-auto" tag="div"><img src="/icons/arrow-right.svg" alt="Select" /></Button>
            </ListGroupItem>
            <ListGroupItem tag={Link} to={{pathname: 'code', state: { prevPath: this.props.location.pathname, number: '9377' }}} className="d-flex">
              <div>
                <h3 className="text-primary" style={{ marginBottom: '4px' }}>(***) ***-9377</h3>
              </div>
              <Button color="primary" className="btn-icon ml-auto" tag="div"><img src="/icons/arrow-right.svg" alt="Select" /></Button>
            </ListGroupItem>
            <ListGroupItem tag="a" href="/dtc/verify/id-upload" className="d-flex text-secondary font-weight-bold">
              None of these are mine
            </ListGroupItem>
          </ListGroup>
        </Card>
        <p className="animated fadeInUp delay-700ms">Make sure your phone is nearby. This code will expire after 15 minutes.</p>
      </div>
    )
  }
}

export default ListText;
